import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { Select, Store } from '@ngxs/store';
import { NavigationState } from '../../stores/navigation/navigation.state';
import {
  ToggleSidebar,
  StartLoading,
  FinishLoading,
  SetLinks
} from '../../stores/navigation/navigation.actions';
import { AuthState } from '../../stores/auth/auth.state';
import { LogoutRequest } from '../../stores/auth/auth.actions';

@Component({
  selector: 'leagueplay-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  title = 'leagueplay';

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public store: Store
  ) {}

  @Select(NavigationState.sidebarExpanded) sidebarExpanded$: Observable<
    boolean
  >;
  @Select(NavigationState.sideLinks) sidebarLinks$: Observable<any[]>;
  @Select(NavigationState.isLoading) isLoading$: Observable<boolean>;

  @Select(AuthState.user) user$: BehaviorSubject<any>;

  // This may need to be an observable on state later
  profileItems = [
    { label: 'PROFILE', value: 'profile' },
    { label: 'SETTINGS', value: 'settings' },
    { label: 'LOGOUT', value: 'logout' }
  ];

  ngOnInit() {
    this.store.dispatch(new StartLoading());

    setTimeout(() => {
      this.store.dispatch(new FinishLoading());
    }, 1000);

    this.route.params.subscribe(params => {
      console.log('params updated', params);
    });

    this.store.select(NavigationState.currentUri).subscribe(url => {
      if (url) {
        console.log('proceedin to', url);
        this.router.navigateByUrl(url);
      }
    });
  }

  getParams() {
    return {
      returnUrl: window.location.pathname
    };
  }
  sidebarLinkSelected(link) {}

  sidebarToggled() {
    this.store.dispatch(new ToggleSidebar());
  }

  profileItemSelected(value) {
    if (value === 'logout') {
      const path = window.location.pathname;
      this.store.dispatch(new LogoutRequest(path));
    } else if (value === 'profile') {
      this.user$.subscribe(user => {
        this.router.navigate(['profile', user.username]);
      });
    }
  }
}
